import React from "react";

import { default as Button } from "@ds-developer/button";
import { ButtonProps } from "@ds-developer/button/dist/types";
import { withStyles } from "@material-ui/core";

const StyledButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 18,
    fontWeight: 700,
    letterSpacing: "0.3px",
    padding: "10px 24px",
    color: "#2B2D32",
    backgroundColor: "#FFCC00",
    borderColor: "#FFCC00",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: "#ffdc4e",
      borderColor: "#ffdc4e",
      boxShadow: "none",
      color: "#2B2D32",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "#d9ad00",
      borderColor: "#d9ad00",
    },
    "&.bsm": {
      color: "#FFFFFF",
      fontFamily: "Poppins !important",
      fontSize: "16px",
      fontWeight: 600,
      letterSpacing: "-0.3px",
      padding: "8px 27px",
      backgroundColor: "#F9812A",
      borderColor: "#F9812A",
      borderRadius: "8px",
      boxShadow:
        "0px 0.181px 0.317px 0px rgba(86, 65, 41, 0.03), 0px 0.501px 0.877px 0px rgba(86, 65, 41, 0.05), 0px 1.206px 2.11px 0px rgba(86, 65, 41, 0.08), 0px 4px 7px 0px rgba(86, 65, 41, 0.10), 0px 11px 12px -15px #FF5906",
      "&:hover": {
        backgroundColor: "#ff9345",
        borderColor: "#ff9345",
        color: "#FFFFFF",
      },
      "&:active": {
        backgroundColor: "#b65d1d",
        borderColor: "#b65d1d",
      },
    },
    "&:disabled": {
      backgroundColor: "#C7C8CA",
      borderColor: "#C7C8CA",
      color: "#727375",
      boxShadow: "none",
      cursor: "not-allowed",
    },
  },
})(Button);

export const AcceptanceButton = (props: ButtonProps & { brand: string }) => (
  <StyledButton {...props} className={props.brand === "BSM" ? "bsm" : "aa"} />
);
